import React from "react";
import { NavLink } from "react-router-dom";
import logo from '../../../assets/gymea-edu-logo.png';

interface MobileNavBarBrandProps {
  handleClick: () => void;
}

export const MobileNavBarBrand: React.FC<MobileNavBarBrandProps> = ({
  handleClick,
}) => {
  return (
    <div onClick={handleClick} className="mobile-nav-bar__brand">
      <NavLink to="/" className="mobile-nav-bar__link">
        <img
          className="mobile-nav-bar__logo"
          src={logo}
          alt="Gymea Edu"
        />
      </NavLink>
    </div>
  );
};
